import { colors } from 'theme/colors'
import { PassageSectionRange } from 'pagesNew/QuestionBanks/Form/validatePassages'

export const GRE_PRACTICE_TEST_QUESTION_COUNT = 57

export const GRE_SECTIONS: PassageSectionRange[] = [
  { start: 1, end: 12, label: '1st Section' },
  { start: 13, end: 27, label: '2nd Section: Easy' },
  { start: 28, end: 42, label: '2nd Section: Medium' },
  { start: 43, end: 57, label: '2nd Section: Hard' },
]

export const GRE_SECTIONS_HINT =
  'Questions 1–12: 1st Section. 13–27: 2nd Section: Easy. 28–42: 2nd Section: Medium. 43–57: 2nd Section: Hard.'

export const getGreSectionBadge = (questionNumber: number) => {
  const section = GRE_SECTIONS.find(
    (sectionItem) => questionNumber >= sectionItem.start && questionNumber <= sectionItem.end
  )

  if (!section) {
    return null
  }

  return { text: section.label, color: colors.blue }
}
